if (document.getElementById('vue-debit')) {
	Vue.use(VeeValidate);
	new Vue({
		delimiters: ['[[', ']]'],
		mixins: [baseMixin, eventHubMixin, headerMixin, languageMixin, apiMixin],
		el: '#vue-debit',
		data: {
			rib: {
				label: gettext('Merci de joindre votre RIB'),
				placeholder: gettext('Ajouter un RIB'),
				model: {}
			},
			direct_debit_date: {
				value: 5
			},
			options: [{
				label: gettext("Le 5 du mois"),
				value: 5
			}, {
				label: gettext("Le 15 du mois"),
				value: 15
			}],
			user: JSON.parse(localStorage.getItem('user')),
			formDisabled: false,
			notifications: []
		},
		created() { },
		computed: {
			residentId: function () {
				return Number.isInteger(parseInt(getLastUrlSegment())) ? parseInt(getLastUrlSegment()) : this.user.id;
			}
		},
		methods: {
			uploadFile() {
				let formdata = new FormData();
				formdata.append('resident', this.residentId);
				formdata.append('document_type', 'direct_debit');
				formdata.append('files', this.rib.model.value);
				formdata.append('direct_debit_date', this.direct_debit_date.value);
				this.post('documents', formdata)
					.then((response) => {
						this.formDisabled = true;
						// console.log(response);
					})
					.catch((error) => {
						Object.keys(error.response.data).map((el) => {
							this.errors.add({
								field: el,
								msg: error.response.data[el][0].constructor === Array ? error.response.data[el][0][0] : error.response.data[el][0]
							});
						});
					});
			}
		}
	});
}
